import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { NsRadioInput } from 'components/common/ns-radio-input/NsRadioInput';
import { NsCheckboxInput } from 'components/common/ns-checkbox-input/NsCheckboxInput';

import {
  selectDetails as selectAccountDetails,
  setAccountField
} from 'state/account/account-slice';

import { stringToBool } from 'utils/misc';

export const radioOptions = [
  {
    value: 'true',
    label: 'I’m moving in or have moved in recently'
  },
  {
    value: 'false',
    label: 'I want to change the account holder'
  }
];

export const ChangeTenancy = () => {
  const dispatch = useDispatch();

  const { isChangeOfTenancy, isChangeOfName } = useSelector(
    selectAccountDetails,
    shallowEqual
  );

  const handleCheckboxChange = (event) => {
    const { name, value } = event.target;
    const checked = value === 'true';
    dispatch(setAccountField({ name, value: !checked }));
    if (checked) {
      //If it is not isChangeOfName, that means it is not change of tenancy either and it shout reset COT flag.
      dispatch(setAccountField({ name: 'isChangeOfTenancy', value: null }));
    }
  };

  const handleRadioChange = (event) => {
    const {
      target: { value, name }
    } = event;
    dispatch(setAccountField({ name, value: stringToBool(value) }));
  };

  return (
    <>
      <NsCheckboxInput
        name="isChangeOfName"
        onChange={handleCheckboxChange}
        value={!isChangeOfName}
        options={[
          {
            label: 'My name is on the energy bills for this address',
            value: 'true'
          }
        ]}
      />
      {isChangeOfName && (
        <NsRadioInput
          heading="Please let us know why so we can inform the current supplier"
          name="isChangeOfTenancy"
          dataTestId="radioChangeTenancyTestId"
          onChange={handleRadioChange}
          value={`${isChangeOfTenancy}`}
          options={radioOptions}
        />
      )}
    </>
  );
};
